import { inject, observer } from 'mobx-react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import withRouter from '@/components/withRouter';
import s from './styles/Event.module.scss';
import { useEffect, useState } from 'react';
import Arrow from './components/Arrow/Arrow';
import { Display } from '@/components/Display/Display';
import AnswerSheet from './components/AnswerSheet';
import { Button, Space } from 'antd';
import FeedBackModal from './components/FeedBackModal';
import { Storage } from '@/utils/Storage';
import { questionTypeMap, feedBackTypeMap } from '@/utils/contants/caseSimulation';
import { handleSubmitAnswerSheet } from '@/api/grt/simulation';
import SimulationImg from '../components/SimulationImg';
import { getSearchStr } from '@/utils/Page';
const searchStr = getSearchStr();
const EventCard = (props) => {
    const [isFirst, setIsFirst] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    const [resultModal, setResultModal] = useState(false);
    const [resultData, setResultData] = useState({});
    const {
        store: { simulation }
    } = props;
    const [eventStatus, setEventStatus] = useState(1); //1:事件描述 2:答题区域
    const {
        curEventIndex,
        events,
        pageShowEvent,
        curEventData,
        setHeaderIcon,
        curQuestionIndex,
        curQuestion,
        curUserAnswer,
        resetCurUserAnswer,
        changeCurEventIndex,
        changeCurQuestionIndex,
        loading,
        setLoading,
        verifyLogin
    } = simulation;

    useEffect(() => {
        simulation.updatePageShowEvent();
    }, [curEventIndex, events]);
    const onClickArrow = () => {
        setEventStatus(2);
    };
    const goEventResult = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/event-result${searchStr}`, { replace: true });
    };
    const onNext = () => {
        if (curEventData.questions.length === curQuestionIndex + 1) {
            if (curEventIndex === events.length - 1) {
                goEventResult();
                return;
            } else {
                //下一个事件
                setEventStatus(1);
                changeCurEventIndex(curEventIndex + 1);
            }
        } else {
            //下一个问题

            changeCurQuestionIndex(curQuestionIndex + 1);
            setEventStatus(2);
        }

        setResultModal(false);
    };
    //重新选择
    const onReChose = () => {
        resetCurUserAnswer();
        setResultModal(false);
    };
    const getCustomId = (options) => {
        let obj = options.find((item) => item.customer_input);
        return obj;
    };
    const isCanSubmit = () => {
        let canSubmit = true;
        let submitData = {
            ...curUserAnswer
        };

        if (curQuestion.question_type === questionTypeMap.short_answer) {
            if (!curUserAnswer.custom_value || curUserAnswer.custom_value.trim() === '') {
                canSubmit = false;
            }
        }
        if (curQuestion.question_type !== questionTypeMap.short_answer) {
            if (curUserAnswer?.user_answer.length === 0) {
                canSubmit = false;
            }
            let customItem = getCustomId(curQuestion.options);
            //如果有自定义选项，且用户选择自定义选项，未输入自定义值，则不能提交
            if (customItem) {
                submitData.user_answer = submitData.user_answer.filter((item) => item !== customItem.id);
                if (curUserAnswer.user_answer.includes(customItem.id) && (!curUserAnswer.custom_value || curUserAnswer.custom_value.trim() === '')) {
                    canSubmit = false;
                }
            } else {
                curUserAnswer.custom_value = '';
            }
        }
        return { canSubmit, submitData };
    };
    //答题
    const onSubmit = async () => {
        let isLogin = await verifyLogin();
        if (!isLogin) {
            return;
        }
        let { canSubmit, submitData } = isCanSubmit();
        if (!canSubmit) {
            return;
        }
        setErrorMsg('');
        setLoading(true);
        let res = await handleSubmitAnswerSheet({
            runtime_session_id: caseId,
            question_id: curQuestion.question_id,
            ...submitData
        });
        if (res && res.success) {
            console.log(res, '提交答案');
            setResultData(res?.data);
            if (res?.data?.feedback_mode === feedBackTypeMap.notBack) {
                //不需要反馈直接进入下一个
                onNext();
            } else {
                //需要反馈
                setResultModal(true);
            }

            setLoading(false);
        } else {
            setErrorMsg(res?.msg || '提交失败');
            setLoading(false);
        }

        // setResultModal(true);
    };
    useEffect(() => {
        setHeaderIcon({
            role: true,
            back: true,
            reStart: true
        });
        let roleGuide = Storage.get(simulation.roleStorageName);
        if (!roleGuide) {
            setTimeout(() => {
                simulation.setGuideModal('role');
            }, 2000);
        }
    }, []);

    useEffect(() => {
        setIsFirst(true);
        setTimeout(() => {
            setIsFirst(false);
        }, 300);
    }, [curEventIndex]);
    return (
        <>
            <FeedBackModal resultData={resultData} show={resultModal} onNext={onNext} onReChose={onReChose}></FeedBackModal>

            <div className={s['event-card-container']}>
                {/* 左侧导航栏 */}

                <div className={s['sidebar']} style={{ visibility: isFirst ? 'hidden' : 'visible' }}>
                    {pageShowEvent.map((item, index) => {
                        return (
                            <div
                                key={index}
                                data-position={curEventIndex - item.originalIndex}
                                data-active={index === curEventIndex}
                                className={s['sidebar-item']}
                            >
                                <Space>
                                    <span>{item?.originalIndex < 9 ? '0' + (item?.originalIndex + 1) : item?.originalIndex + 1}</span>
                                    <span> {item?.scenario_title}</span>
                                </Space>
                            </div>
                        );
                    })}

                    <Display show={curEventIndex < events.length - 1}>
                        <ul className={s['sidebar-dot-list']}>
                            {[0, 1, 2, 3].map((item, index) => {
                                return <li key={index} style={{ '--index': index + 1 }} data-index={index} className={s['sidebar-dot-item']}></li>;
                            })}
                        </ul>
                        <div className={s['page-num']}>{events.length < 10 ? '0' + events.length : events.length}</div>
                    </Display>
                </div>

                {/* 主内容区 */}
                <div className={s['main-content']}>
                    <Display show={eventStatus === 1}>
                        <div className={s['event-content']}>
                            <Display show={!isFirst}>
                                <Arrow onClick={onClickArrow} className={s['arrow-wrapper']}></Arrow>
                            </Display>

                            {/* 事件标题 */}
                            <div className={s['event-title']}>{curEventData?.scenario_title}</div>
                            {/* 事件图片 */}
                            <div className={`${s['event-image-wrapper']} ${!isFirst ? s['fadeOut'] : ''}`}>
                                <SimulationImg src={curEventData?.scenario_image} alt={curEventData?.scenario_title} className={s['event-image']} />
                            </div>
                            <Display show={!isFirst}>
                                {/* 文字说明 */}
                                <div className={s['event-desc']}>{curEventData?.scenario_description}</div>
                            </Display>
                        </div>
                    </Display>
                    <Display show={eventStatus === 2}>
                        <div className={s['answer-content']}>
                            <div className={s['answer-event-content-wrapper']}>
                                <div className={s['answer-event-back']}>事件回顾</div>
                                <div className={s['answer-event-content']}>{curEventData?.scenario_description}</div>
                            </div>
                            <AnswerSheet></AnswerSheet>
                        </div>
                        <div className={s['submit-btn-wrapper']}>
                            <Button
                                disabled={!isCanSubmit().canSubmit}
                                loading={loading}
                                onClick={onSubmit}
                                type="primary"
                                shape="round"
                                size="large"
                                style={{ width: 200 }}
                            >
                                {loading ? '正在提交' : '提交'}
                            </Button>
                        </div>
                        <Display show={errorMsg}>
                            <div className={s['error-msg-wrapper']}>
                                <ExclamationCircleOutlined />
                                <span className={s['error-msg']}>分析失败，请重新提交</span>
                            </div>
                        </Display>
                    </Display>
                </div>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(EventCard)));
